// src/config/env.js
import DefaultImage from "../assets/images/logo-square.jpg";
const MODE = "production";
// "local" | "production"


const CONFIG = {
  local: {
    FRONTEND: "http://localhost:3000",
    BACKEND: "http://localhost:8000",
  },

  production: {
    FRONTEND: "https://admin-page.mstender.com",
    BACKEND: "https://backend.mstender.com",
  },
};

const CURRENT = CONFIG[MODE];

const env = {
  APP_NAME: "MS Tender",

  // Environment
  MODE,

  // URLs
  FRONTEND_URL: CURRENT.FRONTEND,
  BACKEND_URL: CURRENT.BACKEND,

  BASE_URL: CURRENT.BACKEND,
  API_URL: `${CURRENT.BACKEND}/api`,

  // Authentication
  TOKEN_KEY: "token",

  // Images
  IMAGE_PATH: CURRENT.BACKEND,
  
  DEFAULT_PROFILE: DefaultImage,

  // App settings
  DATE_FORMAT: "YYYY-MM-DD",
  CURRENCY: "₹",
  TIMEZONE: "Asia/Kolkata",

  // Features
  DEBUG_MODE: MODE === "local",
  ENABLE_NOTIFICATIONS: true,

  // Pusher
  PUSHER_APP_KEY: "6584f9be51b668dd36b0",
  PUSHER_APP_CLUSTER: "ap2",
};

export default env;
